<template>

    <div class="modal attendance-modal fade" id="announcementModal" tabindex="-1" aria-labelledby="announcementModal" aria-hidden="true" style="z-index:99999;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">{{ isEditing ? 'Mededeling bewerken' : 'Nieuwe mededeling' }}</p>
                    </div>
                    <button type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body pt-3 pb-4 px-4">

                    <!-- Title -->
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Titel</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="announcement.title"
                            placeholder="Titel van de mededeling"
                        >
                    </div>

                    <!-- Description -->
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Beschrijving</label>
                        <textarea
                            ref="descriptionEditor"
                            class="form-control"
                            rows="3"
                            placeholder="Beschrijving van de mededeling"
                        ></textarea>
                    </div>

                    <div class="mb-3 d-flex gap-3">
                        <!-- Published -->
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="published"
                                v-model="announcement.published"
                            >
                            <label class="form-check-label" for="published">Gepubliceerd</label>
                        </div>

                        <!-- Show Popup -->
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="showPopup"
                                v-model="announcement.show_popup"
                            >
                            <label class="form-check-label" for="showPopup">Toon als popup</label>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-6">
                            <!-- Date From -->
                            <div class="mb-3">
                                <label class="form-label fw-semibold">Datum vanaf</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    v-model="announcement.date_from"
                                    placeholder="Selecteer startdatum"
                                >
                            </div>
                        </div>
                        <div class="col-md-6">
                            <!-- Date Till -->
                            <div class="mb-3">
                                <label class="form-label fw-semibold">Datum tot</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    v-model="announcement.date_till"
                                    placeholder="Selecteer einddatum"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- Roles -->
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Selecteer de gewenste rollen</label>
                        </div>
                        <div class="col-md-6 text-end">
                            <button @click="selectAll();" class="btn btn-primary ms-auto px-3 py-2 text-sm">Selecteer alle</button>
                            <button @click="selectNone();" class="btn btn-primary ms-auto px-3 py-2 text-sm">Deselecteer alle</button>
                        </div>
                    </div>

                    <div class="modal-body py-3">
                        <div class="employees-list" v-if="roles.length > 0">
                            <label class="employee" v-for="role in roles" :key="role.id" role="button">
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        <input
                                            v-model="role.selected"
                                            type="checkbox"
                                            v-bind:id="role.id"
                                        >
                                        <div>
                                            {{ role.name }}
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="modal-body pt-0 pb-4 px-4 d-flex">
                    <button
                        class="btn btn-primary ms-auto px-3 py-2 text-sm"
                        @click="saveAnnouncement()"
                        :disabled="!canCreateAnnouncement"
                    >
                        {{ isEditing ? 'Mededeling opslaan' : 'Mededeling aanmaken' }} <i class="fa fa-save" :class="{ 'fa fa-circle-o-notch fa-spin' : this.btnActionLoader }"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";
import Multiselect from "vue-multiselect";

export default {
    name: 'announcement-modal',
    components: {
        Multiselect
    },
    data() {
        return {
            announcement: {
                id: null,
                title: '',
                description: '',
                published: false,
                date_from: '',
                date_till: '',
                show_popup: false,
                roles: '',
            },
            roles: [],
            isEditing: false,
            loading: false,
            btnActionLoader: false,
        }
    },
    computed: {
        canCreateAnnouncement() {
            // Check if title is not empty
            return this.announcement.title.trim() !== ''
                && this.announcement.date_from !== ''
                && this.announcement.date_till !== '';
        },
    },
    methods: {
        initRedactor() {
            this.$nextTick(() => {
                const $textarea = $(this.$refs.descriptionEditor);

                // Destroy existing instance if any
                if ($textarea.data('redactor')) {
                    $textarea.redactor('core.destroy');
                }

                $textarea.redactor({
                    toolbarFixed: false,
                    minHeight: 100,
                    lang: 'nl',
                    plugins: ['properties', 'source', 'iconic'],
                });

                // Set content if editing
                if (this.announcement.description) {
                    $textarea.redactor('code.set', this.announcement.description);
                }
            });
        },
        syncDescriptionFromRedactor() {
            const $textarea = $(this.$refs.descriptionEditor);
            if ($textarea.data('redactor')) {
                this.announcement.description = $textarea.redactor('code.get');
            }
        },
        loadRoles() {
            return axios.get('api/get-profiles')
            .then(response => {
                if (response.data.status === 422) {
                    throw [true, response.data.message];
                }

                 this.roles = response.data.profiles.map(profile => ({
                    ...profile,
                    selected: false
                }));
            })
            .catch(e => {
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de rollen.", "error");
                return [];
            });
        },
        saveAnnouncement() {
            this.syncDescriptionFromRedactor();

            this.btnActionLoader = true;

            const selectedRoles = this.roles
                .filter(role => role.selected)
                .map(role => role.id);

            this.announcement.roles = selectedRoles.join(',');

            const endpoint = this.isEditing ?
                `api/update-announcement/${this.announcement.id}` :
                'api/add-announcement';

            axios.post(endpoint, this.announcement)
                .then(response => {
                    if (response.data.status === 422) {
                        this.modal.hide();
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('refetchAnnouncements');
                    this.btnActionLoader = false;

                    setTimeout(() => this.modal.hide(), 500);
                })
            .catch(e => {
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de mededeling.", "error");
            });
        },
        resetForm() {
            this.announcement = {
                id: null,
                title: '',
                description: '',
                published: true,
                date_from: '',
                date_till: '',
                show_popup: true,
                roles: '',
            };
            this.isEditing = false;

            // Reset role selection
            if (this.roles.length > 0) {
                this.roles.forEach(role => {
                    role.selected = true;
                });
            }
        },
        selectAll() {
            this.selectRoles(true);
        },
        selectNone() {
            this.selectRoles(false);
        },
        selectRoles(state) {
            if (this.roles.length > 0) {
                this.roles.forEach(role => {
                    role.selected = state;
                });
            }
        },
        setAnnouncementForEdit(announcement) {
            this.announcement = { ...announcement };

            // Parse roles string to array and set selected roles
            if (announcement.roles) {
                const roleIds = announcement.roles.split(',').map(id => parseInt(id.trim()));
                this.roles.forEach(role => {
                    role.selected = roleIds.includes(role.id);
                });
            }

            this.isEditing = true;
        }
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('announcementModal'));

        // Initialize redactor after the modal is fully shown (DOM visible)
        document.getElementById('announcementModal').addEventListener('shown.bs.modal', () => {
            this.initRedactor();
        });

        EventBus.$on('openAnnouncementModal', (announcement = null) => {
            // Store the announcement for later use
            const announcementToEdit = announcement;

            // Load roles first, then set announcement for edit if needed
            this.loadRoles().then(() => {

                // Reset form if not editing
                if (!announcementToEdit) {
                    this.resetForm();
                }

                if (announcementToEdit) {
                    this.setAnnouncementForEdit(announcementToEdit);
                }
            });

            this.modal.show();
        });
    }
}
</script>
